import * as React from "react";
import GridRow, { GridRowValue } from "./GridRow";

export interface GridSectionValue
{
    rows: GridRowValue[];
}

interface GridSectionProps
{
    section: GridSectionValue;
}

const GridSection: React.FC<GridSectionProps> = (props) =>
{
    return (
        <div className="w-full">
            {props.section.rows.map((row, i) =>
            {
                return <GridRow key={`rk_${i}`} {...row} />;
            })}
        </div>
    );
};

export default GridSection;
